module.exports = __webpack_public_path__ + "static/pr-op-planning@3x-d667ce4ed7b3d7b6f6e7560ae3fa5e04.png";